module.exports = __webpack_public_path__ + "static/media/sun-loan-logo-2.c0239df7.svg";